import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Modal, Spinner } from 'react-bootstrap'
import get from 'lodash.get'

import { useDispatch, useSelector } from 'react-redux'
import * as webformSubmissionsActions from 'store/modules/webformSubmissions/actions'
import WebformSimple from '../../molecules/WebformSimple'
import WebformModal from '../../molecules/WebformModal'

function Webform(props) {
  const { data } = props
  const [formLoading, setFormLoading] = useState(true)
  const [isModal, setIsModal] = useState(false)
  const [showForm, setShowForm] = useState(false)
  const [canClose, setCanClose] = useState(false)
  const [formId, setFormId] = useState('')
  const dispatch = useDispatch()
  let webformSubmissionsData = useSelector((state) => state.webformSubmissions.webformSubmissionsData)
  let loadingWebformSubmissions = useSelector((state) => state.webformSubmissions.loadingWebformSubmissions)
  const { user, loadingUser } = useSelector((state) => state.auth)
  const themeClasses = get(data, 'theme.entity.classes')

  const closeable = get(data, 'closeable')

  useEffect(() => {
    if (formId && !loadingWebformSubmissions && webformSubmissionsData) {
      const submissions = get(webformSubmissionsData, 'webformSubmissions')
      const result = get(submissions, 'result')
      const userSubmitted = get(result, 'userSubmitted')
      if (!userSubmitted) {
        setShowForm(true)
      }
      setFormLoading(false)
    }
  }, [webformSubmissionsData, formId, loadingWebformSubmissions])

  useEffect(async () => {
    localStorage.setItem('auth', JSON.stringify(user))

    const getSubmissions = async (webformId) => {
      const userId = user?.id.toString()
      dispatch(webformSubmissionsActions.getWebformSubmissions({ userId, webformId }))
    }

    const formType = get(data, 'formType')
    const formTypeEntity = get(formType, 'entity')
    const type = get(formTypeEntity, 'type')

    const form = get(data, 'form')
    const id = get(form, 'id')
    setFormId(id)

    if (type === 'termo_aceite_obrigatorio') {
      setIsModal(true)
      await getSubmissions(id)
      setCanClose(false)
    } else if (type === 'termo_aceite') {
      setIsModal(true)
      await getSubmissions(id)
      setCanClose(true)
    } else {
      setFormLoading(false)
      setShowForm(true)
    }
  }, [])

  return (
    <>
      {formLoading && (
        <Row className="justify-content-md-center my-5">
          <Col md="auto" className="text-center">
            <Spinner animation="border" />
          </Col>
        </Row>
      )}
      {!isModal && showForm && <WebformSimple data={{ formId }} themeClasses={themeClasses} />}
      {isModal && showForm && <WebformModal data={{ formId }} closeable={closeable || canClose} />}
    </>
  )
}

export default Webform
